module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 37);
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  0:
  /***/
  function _(module, exports) {
    module.exports = require("react");
    /***/
  },

  /***/
  1:
  /***/
  function _(module, exports) {
    module.exports = require("prop-types");
    /***/
  },

  /***/
  3:
  /***/
  function _(module, exports) {
    module.exports = require("classnames/bind");
    /***/
  },

  /***/
  37:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _Loader = __webpack_require__(5);

    var _Loader2 = _interopRequireDefault(_Loader);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    exports.default = _Loader2.default;
    /***/
  },

  /***/
  5:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    exports.default = Loader;

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    var _propTypes = __webpack_require__(1);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _bind = __webpack_require__(3);

    var _bind2 = _interopRequireDefault(_bind);

    var _color = __webpack_require__(6);

    var _color2 = _interopRequireDefault(_color);

    var _general = __webpack_require__(7);

    var _general2 = _interopRequireDefault(_general);

    var _sizes = __webpack_require__(8);

    var _sizes2 = _interopRequireDefault(_sizes);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var cx = _bind2.default.bind(_extends({}, _color2.default, _general2.default));

    function Loader(_ref) {
      var size = _ref.size,
          color = _ref.color;
      var smallBorder = size === 'extraSmall' || size === 'small';
      var className = cx('loader', color);
      var style = {
        width: _sizes2.default[size],
        height: _sizes2.default[size],
        borderWidth: smallBorder ? 1 : 2
      };
      return _react2.default.createElement('div', {
        className: className,
        style: style
      });
    }

    Loader.propTypes = {
      size: _propTypes2.default.oneOf(Object.keys(_sizes2.default)),
      color: _propTypes2.default.oneOf(Object.keys(_color2.default))
    };
    Loader.defaultProps = {
      size: 'medium',
      color: 'silver'
    };
    /***/
  },

  /***/
  6:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "white": "color__white___1SJ9j borderColor-white borderRightColor-transparent",
      "smoke": "color__smoke___35Of1 borderColor-smoke borderRightColor-transparent",
      "darkSmoke": "color__darkSmoke___j493w borderColor-smoke--d borderRightColor-transparent",
      "silver": "color__silver___2GAUx borderColor-silver borderRightColor-transparent",
      "blue": "color__blue___3N6dr borderColor-blue borderRightColor-transparent"
    };
    /***/
  },

  /***/
  7:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "loader": "general__loader___2CseQ animation-spin borderRadius-circle borderStyle-solid display-block transitionDuration-m transitionProperty-opacity transitionTimingFunction-ease-in-out"
    };
    /***/
  },

  /***/
  8:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var loaderSize = {
      extraLarge: 22,
      large: 14,
      medium: 14,
      small: 8,
      extraSmall: 6
    };
    exports.default = loaderSize;
    /***/
  }
  /******/

});